var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRulerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_regla") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kiosko",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ficha",
    transform: "translate(-2012, -1224)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_regla",
    transform: "translate(2012, 1224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.027589,71.5681727 C15.2866853,71.8560576 15.6609356,72 16.0351859,72 C16.4094362,72 16.7836865,71.8560576 17.0715714,71.5681727 L71.5681727,17.0715714 C72.1439424,16.4958017 72.1439424,15.6033587 71.5681727,15.027589 L56.972411,0.431827269 C56.3966413,-0.143942423 55.5041983,-0.143942423 54.9284286,0.431827269 L0.431827269,54.9284286 C-0.143942423,55.5041983 -0.143942423,56.3966413 0.431827269,56.972411 L15.027589,71.5681727 Z M16.0351859,68.5165934 L3.48340664,55.9648141 L7.71531387,51.7329068 L16.8412635,60.8588565 L18.8852459,58.8148741 L9.75929628,49.6889244 L14.6533387,44.794882 L20.4398241,50.5813675 L22.4838065,48.537385 L16.6973211,42.7508996 L21.5913635,37.8568573 L27.3778489,43.6721311 L29.4218313,41.6281487 L23.6353459,35.8128749 L28.5293882,30.9188325 L37.5113954,39.9008397 L39.5553778,37.8568573 L30.5733707,28.8748501 L35.467413,23.9808077 L41.2826869,29.7672931 L43.3266693,27.7233107 L37.5401839,21.9080368 L42.4342263,17.0139944 L48.2495002,22.8004798 L50.2934826,20.7564974 L44.5069972,14.9412235 L49.4010396,10.0471811 L58.3830468,19.0291883 L60.4270292,16.9852059 L51.445022,8.00319872 L55.9360256,3.51219512 L68.4878049,16.0639744 L16.0351859,68.5165934 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerWhite);
export default __webpack_public_path__ + "static/media/ruler-white.483430165c2f332ecaea335c6c3d7293.svg";
export { ForwardRef as ReactComponent };